import React from 'react';
import { PageLayout } from '../../components/PageLayout';
import { HeaderBanner } from './HeaderBanner';
import { IntroCallout } from './IntroCallout';
import { CourseRules } from './CourseRules';
import { Pricing } from './Pricing';
import { Gallery } from './Gallery';
import { QuickLinks } from './QuickLinks';
export function SportingClaysPage() {
  return <PageLayout data-id="element-3300">
      <HeaderBanner data-id="element-3301" />
      <IntroCallout data-id="element-3302" />
      <CourseRules data-id="element-3303" />
      <Pricing data-id="element-3304" />
      <Gallery data-id="element-3305" />
      <QuickLinks data-id="element-3306" />
    </PageLayout>;
}